<template>
  <div class="row">
    <div class="col-xs-12 explanation">
      <p>
        {{ trans('subscription.subscribable_groupings.create_explanation_start') }}
      </p>
      <p>
        {{ trans('subscription.subscribable_groupings.create_explanation_middle') }}
      </p>
      <p>
        {{ trans('subscription.subscribable_groupings.create_explanation_end') }}
      </p>

      <p>
        <a
          :href="helpLink"
        >{{ trans('subscription.subscribable_groupings.create_explanation_link') }}</a>
      </p>
    </div>

    <div
      v-if="!isStored"
      class="col-xs-12"
    >
      <radio-component
        id="type"
        v-model="subscribablesType"
        :label="trans('subscription.subscribable_groupings.create_grouping_for')"
        :value="subscribablesType"
        :options="radioOptions"
        :errormessage="errormessage.type"
      />
    </div>

    <div
      v-if="!isStored"
      class="col-xs-12"
    >
      <radio-component
        id="type"
        v-model="hasSubscribables"
        :label="trans_choice('subscription.subscribables', 2)"
        :value="hasSubscribables"
        :options="radioOptionsEmpty"
      />
    </div>

    <div
      v-if="value.hasSubscribables === 'subscribables' || isStored"
      class="col-xs-12"
      style="margin-top:10px;"
    >
      <div class="col-xs-12 extra-text">
        <p>{{ trans('subscription.subscribable_groupings.select_dates') }}:</p>
      </div>

      <div class="col-xs-12">
        <date-picker-component
          id="startdate"
          v-model="startdate"
          :label="trans('core.startdate')"
          :errormessage="errormessage.startdate"
        />
      </div>

      <div class="col-xs-12">
        <date-picker-component
          id="enddate"
          v-model="enddate"
          :label="trans('core.enddate')"
          :errormessage="errormessage.enddate"
        />
      </div>

      <div class="col-xs-12 extra-text">
        <p>{{ trans('subscription.subscribable_groupings.select_names') }}:</p>
      </div>

      <multi-select-component
        id="subscribableNameSelector"
        v-model="subscribableNames"
        :max-selected-options="500"
        :label="trans('subscription.subscribable_groupings.subscribable_names')"
        type="subscribable-name"
        :include="{ 'type': subscribablesType, 'after_date': startdate, 'before_date': enddate, 'program_id': programId }"
      />
    </div>
  </div>
</template>

<script>
import DatePickerComponent from '@/employees/components/FormComponents/DatePickerComponent.vue'
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import RadioComponent from '@/employees/components/FormComponents/RadioComponent.vue'
import { APPOINTMENT, COURSE, EXAM, GROUP, SINGLE } from '@/constants'

export default {

  name: 'SelectComponents',
  components: { DatePickerComponent, MultiSelectComponent, RadioComponent },

  props: {
    isStored: {
      required: true,
      type: Boolean,
    },
    programId: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      errormessage: {
        type: null,
        startdate: null,
        enddate: null,
        names: null,
      },
      typeExam: EXAM,
      typeGroup: GROUP,
      typeSingle: SINGLE,
      typeCourse: COURSE,
      typeAppointment: APPOINTMENT,
    }
  },

  computed: {
    subscribablesType: {
      get () {
        return this.value.subscribablesType
      },
      set (value) {
        this.errormessage.type = null

        const oldValue = this.value.subscribablesType

        this.emitInput('subscribablesType', value)

        if (oldValue !== value) {
          this.$emit('emptySubscribableNames')
        }

        if (![this.typeExam, this.typeGroup, this.typeSingle, this.typeCourse].includes(value)) {
          this.errormessage.type = Lang.trans('subscription.subscribable_groupings.errors.type')
        }
      },
    },
    hasSubscribables: {
      get () {
        return this.value.hasSubscribables
      },
      set (value) {
        if (value === 'empty') {
          this.value.subscribableNames = []
        }
        this.emitInput('hasSubscribables', value)
      },
    },

    startdate: {
      get () {
        return this.value.startdate
      },
      set (value) {
        this.errormessage.startdate = null
        this.errormessage.enddate = null

        this.emitInput('startdate', value)

        if (value > this.value.enddate) {
          this.errormessage.startdate = Lang.trans('subscription.subscribable_groupings.errors.startdate')
        }
      },
    },

    enddate: {
      get () {
        return this.value.enddate
      },
      set (value) {
        this.errormessage.startdate = null
        this.errormessage.enddate = null

        this.emitInput('enddate', value)

        if (value < this.value.startdate) {
          this.errormessage.enddate = Lang.trans('subscription.subscribable_groupings.errors.enddate')
        }
      },
    },

    subscribableNames: {
      get () {
        return this.value.subscribableNames
      },
      set (value) {
        this.emitInput('subscribableNames', value)
      },
    },

    radioOptions () {
      return [
        {
          id: this.typeSingle,
          value: this.typeSingle,
          label: Lang.trans('core.lesson'),
        },
        {
          id: this.typeAppointment,
          value: this.typeAppointment,
          label: Lang.choice('core.appointments', 1),
        },
        {
          id: this.typeExam,
          value: this.typeExam,
          label: Lang.trans('core.exam'),
        },
        {
          id: this.typeGroup,
          value: this.typeGroup,
          label: Lang.trans('core.group'),
        },
        {
          id: this.typeCourse,
          value: this.typeCourse,
          label: Lang.trans('core.course'),
        },
      ]
    },
    radioOptionsEmpty () {
      return [
        {
          id: 'empty',
          value: 'empty',
          label: Lang.trans('subscription.subscribable_groupings.empty_grouping'),
        },
        {
          id: 'subscribables',
          value: 'subscribables',
          label: Lang.trans('subscription.subscribable_groupings.choose_subscribables'),
        },
      ]
    },

    helpLink () {
      return '/help-center?page=' + Lang.get('subscription.subscribable_groupings.help_link')
    },
  },

  methods: {
    checkCanFinish (value) {
      if (((value.subscribableNames == null ||
          value.subscribableNames.length === 0) && value.hasSubscribables === 'subscribables') ||
          value.startdate > value.enddate
      ) {
        this.$emit('canNotFinishStep')
      } else {
        this.$emit('canFinishStep')
      }
    },

    emitInput (key, value) {
      const newValue = { ...this.value, [key]: value }

      this.$emit('input', newValue)

      this.checkCanFinish(newValue)
    },
  },
}
</script>

<style>
    .btn-primary {
        background-color: #25167a !important;
    }

    .explanation {
        margin-bottom: 10px;
    }

    .extra-text {
        margin-top: 15px;
    }
</style>
